import { render, staticRenderFns } from "./HotelCancelled.vue?vue&type=template&id=4adbf0ec&"
import script from "./HotelCancelled.vue?vue&type=script&lang=js&"
export * from "./HotelCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports